:host {
  display: flex;

  --_omk-radio-button-size: var(--omk-radio-button-size, var(--omk-dimension-spacing-large));
  --_omk-radio-button-outer-padding: var(--omk-radio-button-outer-padding, var(--omk-dimension-units-0-5));
  --_omk-radio-button-inner-cirle-size: var(--omk-radio-button-inner-cirle-size, 10px);
  --_omk-radio-button-border-width: var(--omk-radio-button-border-width, var(--omk-dimension-border-width-thick));
  --_omk-radio-button-border-colour: var(--omk-radio-button-border-colour, var(--omk-colour-icon-primary-resting));
  --_omk-radio-button-disabled-border-colour: var(
    --omk-radio-button-border-colour,
    var(--omk-colour-icon-disabled-disabled)
  );

  --_omk-radio-button-checked-border-colour: var(
    --omk-radio-button-checked-border-colour,
    var(--omk-colour-icon-active-resting)
  );
  --_omk-radio-button-error-border-colour: var(
    --omk-radio-button-error-border-colour,
    var(--omk-colour-border-danger-resting)
  );
  --_omk-radio-button-focus-halo-colour: var(
    --omk-radio-button-focus-halo-colour,
    var(--omk-colour-container-primary-focus)
  );
  --_omk-radio-button-hover-halo-colour: var(
    --omk-radio-button-hover-halo-colour,
    var(--omk-colour-container-primary-hover)
  );
  --_omk-radio-button-checked-focus-halo-colour: var(
    --omk-radio-button-checked-focus-halo-colour,
    var(--omk-colour-container-primary-focus)
  );
  --_omk-radio-button-checked-hover-halo-colour: var(
    --omk-radio-button-checked-hover-halo-colour,
    var(--omk-colour-container-success-hover)
  );
  --_omk-radio-button-error-focus-halo-colour: var(
    --omk-radio-button-error-focus-halo-colour,
    var(--omk-colour-container-danger-focus)
  );
  --_omk-radio-button-error-hover-halo-colour: var(
    --omk-radio-button-error-hover-halo-colour,
    var(--omk-colour-container-danger-hover)
  );
  --_omk-radio-button-border-radius: var(--omk-radio-button-border-radius, var(--omk-dimension-border-radius-full));

  border-radius: var(--_omk-radio-button-border-radius);
  background-color: transparent;
  width: var(--_omk-radio-button-size);
  height: var(--_omk-radio-button-size);
  padding: var(--_omk-radio-button-outer-padding);
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.outer-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--_omk-radio-button-border-radius);
  border-color: var(--_omk-radio-button-border-colour);
  border-width: var(--_omk-radio-button-border-width);
  border-style: solid;
  background-color: transparent;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

:host([has-hover]) {
  background-color: var(--_omk-radio-button-hover-halo-colour);
}
:host([checked]) {
  .outer-circle {
    border-color: var(--_omk-radio-button-checked-border-colour);
  }
  .inner-circle {
    background-color: var(--_omk-radio-button-checked-border-colour);
  }
}
:host([checked][has-hover]) {
  background-color: var(--_omk-radio-button-checked-hover-halo-colour);
}
:host([has-error]) {
  .outer-circle {
    border-color: var(--_omk-radio-button-error-border-colour);
  }
  .inner-circle {
    background-color: var(--_omk-radio-button-error-border-colour);
  }
}
:host([has-error][has-hover]) {
  background-color: var(--_omk-radio-button-error-hover-halo-colour);
}
:host([has-focus]) {
  background-color: var(--_omk-radio-button-focus-halo-colour);
}
:host([has-error][has-focus]) {
  background-color: var(--_omk-radio-button-error-focus-halo-colour);
}
:host([disabled]) {
  pointer-events: none;
  .outer-circle {
    border-color: var(--_omk-radio-button-disabled-border-colour);
  }
}
:host([disabled][checked]) {
  .outer-circle {
    border-color: var(--_omk-radio-button-disabled-border-colour);
  }
  .inner-circle {
    background-color: var(--_omk-radio-button-disabled-border-colour);
  }
}

.inner-circle {
  background-color: transparent;
  border-radius: var(--_omk-radio-button-border-radius);
  width: var(--_omk-radio-button-inner-cirle-size);
  height: var(--_omk-radio-button-inner-cirle-size);
}
